module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("folder")]), _vm._v(" " + _vm._s(_vm.title))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "showFilter": true
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(items.item.id))]), _vm._v(" "), _c('td', {
          staticClass: "nowrap"
        }, [_c('div', [_c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.openDetalle(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("remove_red_eye")]), _vm._v(" Detalles\n              ")], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.descargar(items.item)
            }
          }
        }, [_c('v-icon', [_vm._v("file_download")])], 1)], 1)]), _vm._v(" "), _c('td', [_c('v-chip', {
          attrs: {
            "label": "",
            "color": _vm.estados[items.item.estado],
            "text-color": "white"
          }
        }, [_c('small', [_vm._v(_vm._s(items.item.estado.replace(/_/gi, ' ')))])])], 1), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(items.item.nro_apostilla))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(items.item.tramite_cod_seguimiento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item.fecha_expedicion)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.documento_nombre))]), _vm._v(" "), _c('td', [_c('em', [_c('strong', [_vm._v(_vm._s(items.item.tramite_solicitante_tipo_documento) + ": ")]), _vm._v(_vm._s(items.item.tramite_solicitante_nro_documento))]), _c('br'), _vm._v("\n            " + _vm._s(items.item.tramite_solicitante_nombres) + "\n            " + _vm._s(items.item.tramite_solicitante_primer_apellido) + "\n            " + _vm._s(items.item.tramite_solicitante_segundo_apellido) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$datetime.format(items.item._created_at)))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center"
        }, [(items.item.pago_entidad || items.item.pago_cancilleria) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("check")]) : _c('v-icon', {
          attrs: {
            "color": "error"
          }
        }, [_vm._v("close")])], 1)]
      }
    }])
  }, [_c('template', {
    slot: "labels"
  }, [(this.regionales.length > 1) ? _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-select', {
    attrs: {
      "label": "Regional",
      "items": _vm.regionales
    },
    model: {
      value: (_vm.regional),
      callback: function($$v) {
        _vm.regional = $$v
      },
      expression: "regional"
    }
  })], 1) : _c('div', {
    staticClass: "text-xs-right"
  }, [_c('strong', [_vm._v("REGIONAL: ")]), _vm._v(" "), _c('v-chip', {
    attrs: {
      "label": "",
      "color": "info",
      "text-color": "white"
    }
  }, [_vm._v("\n              " + _vm._s(_vm.user.departamento.split(',').join(' - ')) + "\n            ")])], 1)])], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "1200"
    },
    model: {
      value: (_vm.$store.state.modal2),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal2", $$v)
      },
      expression: "$store.state.modal2"
    }
  }, [(_vm.solicitud) ? _c('detalle', {
    attrs: {
      "solicitud": _vm.solicitud
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f1db402","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/tramiteDoc/Historial.vue
// module id = 505
// module chunks = 2